module.exports = __webpack_public_path__ + "static/media/about.be144b81.jpg";